import { useState, useEffect } from "react";
import { searchStories } from "../api/story/requests";
import { useShowErrorFlashMessage } from "../features/flashMessage/store";

function useStoryblokArticlesSearch({ category, tag, type }) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const showErrorFlashMessage = useShowErrorFlashMessage();

  let categoryList = category.split(",")

  if (type) categoryList.push(type)

  useEffect(() => {
    searchStories({ category: categoryList.filter(Boolean).join(','), tag })
      .then((data) => {
        if (data) {
          setData(data.articles);
          setTotal(data.total);
        }
      })
      .catch((err) => {
        if (err.status !== 404) {
          console.error(err);
          showErrorFlashMessage('api.network_error');
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  return [data, total, isLoading];
}

export { useStoryblokArticlesSearch };
